export const iconFontAwesomeAlphabetSquareH = (
	<i className="fa-solid fa-square-h"></i>
);
